export default __webpack_public_path__ + "static/DowntownManagement-aabf242edf63fe87dc7722795f76b659.jpg";